L.Map.mergeOptions({
    // @section Mousewheel options
    // @option smoothWheelZoom: Boolean|String = true
    // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
    // it will zoom to the center of the view regardless of where the mouse was.
    smoothWheelZoom: true,

    // @option smoothWheelZoom: number = 1
    // setting zoom speed
    smoothSensitivity: 1,
});

L.Map.SmoothWheelZoom = L.Handler.extend({
    active: true,
    _gettingWheelPositionTimeout: null,

    stop: function () {
        this.active = false;
    },

    start: function () {
        this.active = true;
    },

    hasElClass: function (element, classname) {
        if (element.className)
            if (
                typeof element.className === "string" ||
                element.className instanceof String
            )
                if (element.className.split(" ").indexOf(classname) >= 0) return true;
        return element.parentNode && this.hasElClass(element.parentNode, classname);
    },

    addHooks: function () {
        L.DomEvent.on(this._map._container, "wheel", this._onWheelScroll, this);
        L.DomEvent.on(this._map._container, "mousemove", this._onMouseMove, this);
    },

    removeHooks: function () {
        L.DomEvent.off(this._map._container, "wheel", this._onWheelScroll, this);
        L.DomEvent.off(this._map._container, "mousemove", this._onMouseMove, this);
    },

    _onMouseMove: function (e) {
        // update current mouse position
        if (!this._gettingWheelPositionTimeout) {
            if (!this._isWheeling) {
                this._wheelMousePosition = this._map.mouseEventToContainerPoint(e);
                this._wheelStartLatLng = this._map.containerPointToLatLng(
                    this._wheelMousePosition
                );
            } else {
                this._gettingWheelPositionTimeout = setTimeout(() => {
                    this._wheelMousePosition = this._map.mouseEventToContainerPoint(e);
                    this._wheelStartLatLng = this._map.containerPointToLatLng(
                        this._wheelMousePosition
                    );
                    this._gettingWheelPositionTimeout = null;
                }, 100);
            }
        }
    },

    _onWheelScroll: function (e) {
        if (this.active && !this.hasElClass(e.target, "ignore-touch")) {
            if (!this._isWheeling) {
                this._onWheelStart(e);
            }
            this._onWheeling(e);
        }
    },

    // fires only once when wheelling starts
    _onWheelStart: function (e) {
        // change _isWheeling to true - it will allow to call _onWheelStart() function only once
        this._isWheeling = true;

        // change _moved to false
        this._moved = false;
        this._zooming = true;

        // get center of the map - we are getting it each time when scroll 
        // starts because someone can change width of the window without page reload
        this._centerPoint = this._map.getSize()._divideBy(2);

        // get prev values
        this._goalZoom = this._map.getZoom();
        this._prevCenter = this._map.getCenter();
        this._prevZoom = this._map.getZoom();

        this._zoomAnimationId = requestAnimationFrame(() => {
            this._updateWheelZoom();
        });
    },

    _onWheeling: function (e) {
        // calculate goal zoom
        this._goalZoom =
            this._goalZoom +
            L.DomEvent.getWheelDelta(e) * 0.003 * this._map.options.smoothSensitivity;

        // if goal zoom is wrong, limit it
        if (this._goalZoom < this._map.getMinZoom() ||
            this._goalZoom > this._map.getMaxZoom()) {
            this._goalZoom = this._map._limitZoom(this._goalZoom);
        } else {
            // If not scroll effect for 200ms, then clear wheel end timeout, and set new one
            clearTimeout(this._wheelEndTimeout);
            this._wheelEndTimeout = setTimeout(() => {
                this._onWheelEnd();
            }, 200);

            L.DomEvent.preventDefault(e);
            L.DomEvent.stopPropagation(e);
        }
    },

    _onWheelEnd: function (e) {
        this._isWheeling = false;
        cancelAnimationFrame(this._zoomAnimationId);
        this._map._moveEnd(true);
    },

    _updateWheelZoom: function () {
        // required to prevent before glitching when try to zoom in or zoom out on max zoom levels
        if ((this._goalZoom >= this._map.getMaxZoom() && (this._map.getZoom() + 0.1) >= this._map.getMaxZoom())) return;
        if ((this._goalZoom <= this._map.getMinZoom() && (this._map.getZoom() - 0.1) <= this._map.getMinZoom())) return;

        // calculate delta - current wheel mouse position - center of the map(always the same)
        var delta = this._wheelMousePosition.subtract(this._centerPoint);

        // if there is no move - delta=0, then return
        if (delta.x === 0 && delta.y === 0) return;

        // calculate the zoom
        this._zoom = Math.floor((this._map.getZoom() + (this._goalZoom - this._map.getZoom()) * 0.3) * 100) / 100;

        // caluclate center latlng by unproject function which takes as
        // a first argument x,y of start mouse position - caluclated delta
        this._center = this._map.unproject(
            this._map.project(this._wheelStartLatLng, this._zoom).subtract(delta),
            this._zoom
        );

        // indicate that move started
        if (!this._moved) {
            this._map._moveStart(true, false);
            this._moved = true;
        }

        // fly to the calculated center and zoom
        this._map.flyTo(this._center, this._zoom, { duration: 0.1, easeLinearity: 0.1 });

        // get current center and zoom
        this._prevCenter = this._map.getCenter();
        this._prevZoom = this._map.getZoom();

        // recursive - make everything in this function again
        this._zoomAnimationId = requestAnimationFrame(() => {
            this._updateWheelZoom();
        });
    },
});

L.Map.addInitHook("addHandler", "smoothWheelZoom", L.Map.SmoothWheelZoom);
